import { BlockStack, Button, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

interface AddTimeDimensionPromptProps {
  addTimeDimension?: () => void;
}
export const AddTimeDimensionPrompt = ({ addTimeDimension }: AddTimeDimensionPromptProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[350px] flex items-center justify-center">
      <BlockStack>
        <Text variant="bodyMd" as="span">
          {t('The selected visualization requires a time dimension.')}
        </Text>
        <Button variant="plain" onClick={() => addTimeDimension?.()}>
          {t('Add dimension')}
        </Button>
      </BlockStack>
    </div>
  );
};
